import { clsx } from 'clsx';

type GoldDividerVariant = 'line' | 'ornament';

type GoldDividerProps = {
  variant?: GoldDividerVariant;
  className?: string;
};

export function GoldDivider({ variant = 'ornament', className }: GoldDividerProps) {
  if (variant === 'line') {
    return (
      <hr
        className={clsx(
          'h-px w-full border-0 bg-gradient-to-r from-transparent via-gold/40 to-transparent',
          className,
        )}
      />
    );
  }

  return (
    <div
      className={clsx('flex w-full items-center justify-center gap-4', className)}
      role="separator"
      aria-hidden="true"
    >
      <span className="h-px flex-1 bg-gradient-to-r from-transparent to-gold/40" />
      <svg viewBox="0 0 24 24" className="h-3 w-3 text-gold" fill="currentColor">
        <circle cx="12" cy="12" r="3" />
      </svg>
      <span className="h-px flex-1 bg-gradient-to-l from-transparent to-gold/40" />
    </div>
  );
}
